import script from "./CategoriesView.vue?vue&type=script&setup=true&lang=js"
export * from "./CategoriesView.vue?vue&type=script&setup=true&lang=js"

import "./CategoriesView.vue?vue&type=style&index=0&id=b5a8ef50&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b5a8ef50"]])

export default __exports__